var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4145 4.12258C28.2556 3.51907 27.9433 2.96835 27.509 2.52529C27.0747 2.08223 26.5334 1.76231 25.9391 1.59742C23.7564 1 15 1 15 1C15 1 6.24364 1 4.06091 1.59742C3.46662 1.76231 2.92533 2.08223 2.491 2.52529C2.05666 2.96835 1.74444 3.51907 1.58545 4.12258C1 6.35226 1 11 1 11C1 11 1 15.6477 1.58545 17.8774C1.74425 18.4812 2.05638 19.0322 2.49073 19.4755C2.92508 19.9188 3.46647 20.2389 4.06091 20.4039C6.24491 21 15 21 15 21C15 21 23.7564 21 25.9391 20.4039C26.5335 20.2389 27.0749 19.9188 27.5093 19.4755C27.9436 19.0322 28.2558 18.4812 28.4145 17.8774C29 15.6503 29 11 29 11C29 11 29 6.35226 28.4145 4.12258ZM12.1364 15.2206V6.78064L19.4545 11.0013L12.1364 15.2206Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4caa375aa40c0797b7d3f677a04f4cf2.svg";
export { ForwardRef as ReactComponent };